<template>
<div class="lvLivingBox">
<!--  直播标题+导航栏 fix-->
  <div class="lvLivingTitleAndBarFix" >

    <!--  直播标题-->
    <div class="lvLivingTitle" >{{ title }}</div>
    <div class="lvLivingTimeStr" >{{ timeStr }}</div>

    <!--  分享按钮-->
<!--    <div class="video_open_app dw" @click="btnOpenApp">打开“嗨科普”观看，清晰又流畅</div>-->
    <div class="video_open_app dw" @click="btnOpenApp">更多内容，请打开“嗨科普”</div>

    <!--  导航栏-->
      <div class="lvLivingBar" >
        <lvTabCtrl @vlTabClick="vlTabClick" ref="lvTabCtrl"></lvTabCtrl>
      </div>
  </div>

  <!--  直播标题+导航栏 占位用 没有实质内容显示-->
  <div class="lvLivingTitleAndBarPlaceHolder" ></div>

  <div>
<!--    直播原版-->
    <!--  图文直播-->
    <lvImgText :baseInfo="baseInfo" :isAction="itemId==0"  v-show="itemId==0" ></lvImgText>
    <!--  聊天室-->
    <lvChat :baseInfo="baseInfo" :isAction="itemId==1"  v-show="itemId==1"></lvChat>
    <!--  直播简介-->
    <lvIntroduction :baseInfo="baseInfo" :isAction="itemId==2" v-show="itemId==2"></lvIntroduction>

<!--    不显示直播内容-->
<!--    <lvIntroduction :baseInfo="baseInfo" :isAction="1" v-show="1"></lvIntroduction>-->
  </div>

</div>
</template>

<script>
import lvTitle from "./lvTitle";
import {apiLive} from "../../../network/app/apiPlatformLive";
import lvAppointmentUser from "./lvAppointmentUser";
import lvIntroduction from "./lvIntroduction";
import lvTabCtrl from "./lvTabCtrl";
import lvImgText from "./lvImgText";
import lvChat from "./lvChat";
import {getFingerPrint} from "../../../js/util/fingerPrint";
import {baseConfig} from "../../../network/baseConfig";
import {utils} from "../../../network/utils";

export default {
  name: "lvLiving",
  props: {
    baseInfo: {
      type: Object,
      required: true
    },
  },
  components:{
    lvTitle,
    lvIntroduction,
    lvTabCtrl,
    lvImgText,
    lvChat
  },
  data(){
    return {
      count: 150,
      itemId: 2,
    }
  },
  computed: {
    title() {
      if (typeof this.baseInfo.title != "undefined") {
        return this.baseInfo.title
      } else {
        return ''
      }
    },
    timeStr(){
      if(typeof this.baseInfo.startTime != "undefined"){
        // return utils.date('m-d l H:i', this.baseInfo.startTime)
        // return this.baseInfo.startTime
        let str = utils.date('Y-m-d H:i', this.baseInfo.startTime)
        str += '~'
        str += utils.date('H:i', this.baseInfo.endTime)
        // console.log(str)
        return str
      }else{
        return '-'
      }
    },
  },
  created() {
    console.log('liLiving created')
    getFingerPrint()
  },
  mounted() {
    console.log('liLiving mounted')
    this.itemId = 0
    this.$refs.lvTabCtrl.setIndex(this.itemId)

  },
  methods:{
    vlTabClick(id){
      // console.log('father receive :'+id)
      this.itemId = id
    },
    btnOpenApp(){
      window.location.href = baseConfig.getAppInfo().href
    }
  }
}
</script>

<style scoped>
.lvLivingBox{
  position: relative;
  margin: auto;
  width: 100%;
  /*background-color: #07c160;*/
}
.lvLivingTitleAndBarFix,
.lvLivingTitleAndBarPlaceHolder{
  position: relative;
  background-color: var(--color-background);

  /*height: 340px;*/
  color: #30353c;

  /*background-color: #ee0a24;*/
  height: 485px;
}
.lvLivingTitleAndBarFix{
  position: fixed;
  left: 0px;
  z-index: 3;
  width: 1080px;
  /*background-color: #0c83ae;*/
}
.lvLivingTitle{
  position: relative;
  color: #30353c;
  width: 100%;
  height: 70px;
  line-height: 70px;
  font-size: 50px;
  padding-left: 45px;
  font-weight: bolder;
  margin-top: 30px;
  /*background-color: #ead287;*/
}
.lvLivingTimeStr{
  position: relative;
  color: #30353d;
  width: 100%;
  height: 55px;
  line-height: 55px;
  font-size: 35px;
  padding-left: 45px;
  margin-top: 30px;
  background-image: url("../../../assets/common/timeBlack.png");
  background-size: 38px 38px;
  background-repeat: no-repeat;
  background-position: 45px center;
  padding-left: 98px;
}
.lvLivingBar{
  position: relative;
  height: 150px;
  /*background-color: #be4079;*/
}
.video_open_app{
  margin: auto;
  margin-top: 30px;
  margin-bottom: 40px;
  width: 800px;
  height: 80px;
  background-color: #fb391e;
  font-size: 40px;
  line-height: 80px;
  color: whitesmoke;
  text-align: center;
  letter-spacing: 0.2em;
  /*font-weight: bolder;*/
  border-radius: 10px;
}
</style>